import { memo } from 'react';
import classNames from 'classnames';
import IconChevronLeftLarge from '@picsart/icons/IconChevronLeftLarge';

import { ReactComponent as PicsartLogoIcon } from '../../../svgIcons/picsart-logo-icon.svg';

import IHeaderProps from './types';
import useStyles from './styles';

function Header({
  className,
  href = window.location.toString(),
  element = 'span',
  text,
}: IHeaderProps) {
  const styles = useStyles();
  const Tag = element;

  return (
    <div className={classNames(styles.root, className)} onClick={() => window.open(href, '_self')}>
      <PicsartLogoIcon />
      <div className={styles.arrowIcon}>
        <IconChevronLeftLarge />
      </div>
      {text && <Tag className={styles.title}>{text}</Tag>}
    </div>
  );
}

export default memo(Header);
